module.exports = __webpack_public_path__ + "img/logo_sm.9b0f8194.png";